module.exports = __webpack_public_path__ + "static/img/4-9.08e15dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zoology/4-9.png
// module id = 1XTg
// module chunks = 15